export const ANIMATED_ELEMENT_DATA_ID = {
  SHAPE_1: 'animated-shape-1',
  SHAPE_2: 'animated-shape-2',
  SHAPE_3: 'animated-shape-3',
  SHAPE_4: 'animated-shape-4'
}
